// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// 1. ADD THIS LINE: Import Firestore so we can use the database
import { getFirestore } from "firebase/firestore"; 

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCC5ztnexiX9GFk4Wi9mykzIblN7udtJXY",
  authDomain: "weekend-availability-f7147.firebaseapp.com",
  projectId: "weekend-availability-f7147",
  storageBucket: "weekend-availability-f7147.firebasestorage.app",
  messagingSenderId: "169293946016",
  appId: "1:169293946016:web:ef9a2c7e82a94200dc3dc5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 2. ADD THIS LINE: Initialize the database and export it
export const db = getFirestore(app);